import { AfterViewInit, Component, Input, OnDestroy, OnChanges, SimpleChanges, QueryList, ViewChildren, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ChartRendererService } from '@shared-lib/shared-services/chart-renderer.service';
import { ConfigService } from '@shared-lib/shared-services/config.service';

@Component({
  selector: 'app-widget-renderer',
  imports: [],
  standalone: true,
  templateUrl: './widget-renderer.component.html',
  styleUrl: './widget-renderer.component.scss'
})
export class WidgetRendererComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input() charts!: any
  @ViewChildren('chartContainer', { read: ViewContainerRef })
  chartContainers!: QueryList<ViewContainerRef>;
  subscription!: Subscription;

  constructor(
    private chartRendererService: ChartRendererService,
    private configService: ConfigService
  ) { }

  ngAfterViewInit(): void {
    this.render();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['charts'] && !changes['charts'].firstChange) {
      this.render();
    }
  }

  private render(): void {
    if (this.chartContainers && this.chartContainers.length > 0) {
      const container = this.chartContainers.first;
      const chart = this.charts;
      if (chart) {
        console.log('[WidgetRenderer] rendering chart', chart?.type, chart?.widgetId);
        this.chartRendererService.renderChart(chart.type, container, chart);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

